/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from 'pdfmake/build/pdfmake';
import moment from 'moment';
import { IPorConta } from '../../../shared/services/api/fiscal/LCDPR/LCDPRService';
 
async function RelatorioPorFazendas(dados: IPorConta[], conta: string, periodo: string){
  
  const TGEntrada = dados.reduce((acc, item) => acc + item.produtor.entrada, 0);
  const TGSaida = dados.reduce((acc, item) => acc + item.produtor.saida, 0);
  
  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous'; 
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }
  
  const imageUrl =  process.env.REACT_APP_URL_IMGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);
  
  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }
    
  const documentDefinition : any = {
    pageSize: 'A4',
    pageMargins: [20, 10, 20, 10],
    pageOrientation: 'landscape',
    content: [
      {
        style: 'tableExample',
        table: {
          margin: [0, 0, 0, 0],  
          widths: [48, 718],  
          body: [
            [ 
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },  
              {
                border: [false, false, false, false],
                table: {
                  widths: [718], 
                  body: [
                    [ 
                      {text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16,  margin: [0, 5, 0, 0], bold: true, color: process.env.COR_RELATORIOS_TEXTO,  alignment: 'center', fillColor: process.env.COR_RELATORIOS, border: [false, false, false, false]},
                    ],
                    [ 
                      {text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true]},
                    ],
                    [ 
                      {text: 'Relatório de LCDPR por Conta', margin: [5, 10, 0, 0], fontSize: 18, bold: true,  alignment: 'center',  border: [false, false, false, false]},
                    ],
                  ]
                }
              }
            ],
          ]
        }
      },
      { text: 'Contas: '+conta+'  '+periodo,  alignment: 'left', fillColor: '#dddddd', fontSize: 10},     
      dados.map(e => {
        const { produtor, lcdpr} = e;
        const TEntrada = lcdpr.reduce((acc, item) => acc + item.entrada, 0);
        const TSaida = lcdpr.reduce((acc, item) => acc + item.saida, 0);
        const rows = lcdpr.map((row) => {
          return [
            {text: moment(row.datacaixa).format('DD/MM/YYYY'), alignment: 'center',  fontSize: 8},
            {text: row.numero, alignment: 'left',  fontSize: 7},
            {text: row.parceiro, alignment: 'left',  fontSize: 7},
            {text: (row.cpf.length == 11 ? (
              row.cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
            ) : (
              row.cpf.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
            )), fontSize: 8, alignment: 'left'},
            {text: row.historico, alignment: 'left',  fontSize: 7},
            {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.entrada), alignment: 'right',  fontSize: 8},
            {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.saida), alignment: 'right',  fontSize: 8},
          ]; 
        });  
  
        return [
          [             
            [                            
              {  
                margin: [0, 5, 0, 0],    
                table: { 
                  body: [   
                    [
                      {text: 'Produtor: '+ produtor.nome, bold: true, fontSize: 9, alignment: 'left', border: [false, false, false, false]}  
                    ],
                  ] 
                },     
              },
              {   
                table:{
                  widths: [45, 60, 200, 75, 255, 50, 50],
                  body: [
                    [
                      {text: 'Data', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
                      {text: 'Número', alignment: 'left', fillColor: '#dddddd', fontSize: 8},
                      {text: 'Parceiro', alignment: 'left', fillColor: '#dddddd', fontSize: 8},
                      {text: 'CPF/CNPJ', alignment: 'left', fillColor: '#dddddd', fontSize: 8},
                      {text: 'Histórico', alignment: 'LEFT', fillColor: '#dddddd', fontSize: 8},
                      {text: 'Entrada', alignment: 'right', fillColor: '#dddddd',  fontSize: 8},
                      {text: 'Saida', alignment: 'right', fillColor: '#dddddd', fontSize: 8}
                    ],
                    ...rows,
                  ]
                },       
              },   
              {     
                table: {
                  widths: [45, 60, 200, 75, 255, 50, 50],
                  body: [
                    [
                      {text: '', border: [false, false, false, false]},
                      {text: '', border: [false, false, false, false]},
                      {text: '', border: [false, false, false, false]},
                      {text: '', border: [false, false, false, false]},
                      {text: 'Totais',  fontSize: 8, alignment: 'right',  border: [false, false, false, false]},
                      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TEntrada), border: [true, false, false, true], alignment: 'right', fontSize: 8},
                      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TSaida), border: [true, false, true, true], alignment: 'right', fontSize: 8},
                    ],
                    [
                      { text: '', border: [false, false, false, true]},
                      { text: '', border: [false, false, false, true]},  
                      { text: '', border: [false, false, false, true]},
                      { text: '', border: [false, false, false, true]},
                      { text: '', border: [false, false, false, true]},  
                      { text: '', border: [false, false, false, true]},
                      { text: '', border: [false, false, false, true]},
                    ]
                  ]
                },       
              }                                          
            ]
          ]                           
              
        ];
      }     
      ),
      {
        table: {
          widths: [572, 100, 100,],
          body: [
            [
              { text: '', border: [false, false, false, false]},  
              { text: '', border: [false, false, false, false]},  
              { text: '', border: [false, false, false, false]},
            ],
            [
              { text: '', border: [false, false, false, false]},  
              { text: '', border: [false, false, false, false]},  
              { text: '', border: [false, false, false, false]},
            ],
            [
              { text: '', border: [false, false, false, false]},  
              { text: 'Entrada', fontSize: 9, alignment: 'right'},  
              { text: 'Saida', fontSize: 9, alignment: 'right'},
            ],
            [
              { text: '', border: [false, false, false, false]}, 
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TGEntrada), fontSize: 10, alignment: 'right'},
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TGSaida), fontSize: 10, alignment: 'right'},
            ],
          ]
        },       
      }
    ]
  };
  pdfMake.createPdf(documentDefinition).open();
}
export default RelatorioPorFazendas;

